module.exports = __webpack_public_path__ + "static/media/semitrailer-2.0baa9d3b.png";